module.exports = __webpack_public_path__ + "media/images/location-small-12ffad7a.png";